import { render, staticRenderFns } from "./AddProductCompany.vue?vue&type=template&id=b3a682f8&scoped=true&"
import script from "./AddProductCompany.vue?vue&type=script&lang=js&"
export * from "./AddProductCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddProductCompany.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddProductCompany.vue?vue&type=style&index=1&id=b3a682f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a682f8",
  null
  
)

component.options.__file = "AddProductCompany.vue"
export default component.exports